import img1 from "../images/iris/img1.jpg";
import img2 from "../images/iris/img2.jpg";
import img3 from "../images/iris/img3.jpg";
import img4 from "../images/iris/img4.jpg";
import img5 from "../images/iris/img5.jpg";
import img6 from "../images/iris/img6.jpg";

export const imgIris = [
  {
    id: 12101,
    image: img1
  },
  {
    id: 12102,
    image: img2
  },
  {
    id: 12103,
    image: img3
  },
  {
    id: 12104,
    image: img4
  },
  {
    id: 12105,
    image: img5
  },
  {
    id: 12106,
    image: img6
  }  
];